// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__PPMQX","btn__white":"button_btn__white__3NWhu"};